export enum LoadingTypeEnum {
  DEFAULT = 'loading-default',
  FULL_SPACE = 'loading-full-space'
}
